import React from 'react';

export function Radio({ label, options, onChange, path, value, disable, requiredField, error }) {
  return (
    <>
      <label className="asterisk-req">
        {label}
        {requiredField && <span>*</span>}
      </label>
      <div className="align-items-center d-flex">
        {options.map((opt, i) => {
          return (
            <p className="custom-radio mb-0 mx-3" key={`${opt?._id}_${i}`}>
              <input
                type="radio"
                id={`radio${i}_${path}`}
                name={`radio${i}_${path}`}
                value={i}
                disabled={disable}
                checked={value === opt?.name}
                onChange={() => onChange(opt?.name, path)}
              />
              <label className="m-0" htmlFor={`radio${i}_${path}`}>
                {opt?.name}
              </label>
            </p>
          );
        })}
        {error?.status && <span className="error-message">{error.errorMsg}</span>}
      </div>
    </>
  );
}
export default Radio;
